/**
 * Main page implementation.
 */

'use strict';

var app  = require('mag-app'),
    keys = require('stb-keys'),

    Page     = require('stb-component-page'),
    PanelSet = require('mag-component-panel-set'),
    //Footer   = require('mag-component-footer'),

    leftPanel  = require('../components/page.main/left.panel'),
    mainPanel  = require('../components/page.main/main.panel'),
    rightPanel = require('../components/page.main/right.panel'),
    footer = require('../components/page.main/footer'),

    exitConfirm = require('../components/widgets/exit.confirm'),

    page     = new Page({$node: window.pageMain}),
    panelSet = new PanelSet({
        $node: window.panelSetMain,
        visible: true,
        focusIndex: 0,
        panels: [leftPanel, mainPanel, rightPanel],
        parent: page
    }),

    popupMenu = require('../components/page.main/popup.menu'),

    lastReceivedIntent = null;


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            if ( panelSet.focusIndex === 1 ) {
                // mainPanel in focus
                if ( mainPanel.back() ) {
                    return;
                }
            }

            if ( lastReceivedIntent === null ) {
                panelSet.blur();
                core.call('stop');
            } else {
                lastReceivedIntent.close();
                lastReceivedIntent = null;
            }
            break;

            // case keys.menu:
            //     console.log(!footer.instance.tabs[0].$body.classList.contains('hidden'))
            //     if ( !footer.instance.tabs[0].$body.classList.contains('hidden') ) {
            //         popupMenu.show();
            //     }
            // break;

        default:
            break;
    }
});


page.once('show', function ( event ) {
    footer.prepare(page);
    page.add(popupMenu);
    mainPanel.focus();

    mainPanel.setData(event.data, function () {
        // do something
    });
});


page.addListener('show', function () {
    app.activePanelSet = panelSet;
});


exitConfirm.addListener('hide', function () {
    if ( app.activePage === page ) {
        panelSet.focus();
    }
});


core.addListener('intent', function ( intent, callback ) {
    if ( intent.action === 'setup' ) {
        mainPanel.reset();
        lastReceivedIntent = intent;
        callback(false, {});
    }
});

// public
module.exports = page;
